import Modal from 'shared/Modal';
import styled from 'styled-components';
import { integrationsHash } from '@constants';
import { Box, Typography, Chip } from '@mui/material';

const Container = styled.div``;

const ModalHeader = styled(Typography)`
  && {
    font-size: 1.5rem;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.text.primary};
    margin-bottom: 0.5rem;
  }
`;

const ModalSubHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

const ModalBody = styled.div``;

const ModalHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  .modal-header {
    flex: 4;
  }
`;

type ProvisionModalPropsTypes = {
  toggle: () => void;
  targetService: string;
  teamId: number;
  body: JSX.Element;
  isRequesting: boolean;
};

export const BaseProvisionModal = ({
  toggle,
  targetService,
  teamId,
  body,
  isRequesting,
}: ProvisionModalPropsTypes) => {
  const integrationTypeHeader = integrationsHash[targetService]?.provisionModalHeaderLabel;

  return (
    <Modal modalWidth={650} open onClose={isRequesting ? undefined : toggle}>
      <Container>
        <ModalHeaderContainer>
          <ModalHeader className="modal-header" variant="h2">
            Provision {integrationTypeHeader} Integration
          </ModalHeader>
        </ModalHeaderContainer>
        <ModalSubHeader>
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              fontWeight: 500,
            }}
          >
            Team ID:
          </Typography>
          <Chip
            label={teamId}
            size="small"
            variant="outlined"
            sx={{
              fontWeight: 600,
              borderRadius: '6px',
            }}
          />
        </ModalSubHeader>
        <ModalBody>{body}</ModalBody>
      </Container>
    </Modal>
  );
};
